var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"},on:{"click":_vm.seeLog}},[_c('Header',{on:{"stickyUpdate":function (val) {
        _vm.stickyHeader = val;
      }}}),_c('div',{staticClass:"content",class:{ sticky: _vm.stickyHeader }},[_c('router-view')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }